import React, { useEffect, useState } from 'react';
import { Button, Card, InputGroup } from 'react-bootstrap';
import { AlignLeft, ArrowLeft, ChevronLeft, ChevronRight } from 'react-feather';
import { Document, Page, pdfjs } from 'react-pdf';




const PDFReader = ({url, footer}) => {
    const [numPages, setNumPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);

    useEffect(() => {
        pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
    }, [])

    const onDocumentLoadSuccess = ({numPages}) => {
        setNumPages(numPages);
    }

    const PageControl = () => (
        <div>
            <div className=''>
                <div className='d-flex justify-content-between align-items-center bg-light shadow rounded-pill overflow-hidden'>
                    <Button disabled={pageNumber <= 1} variant='info' style={{backgroundColor: "#0076ff"}}  onClick={() => setPageNumber(pageNumber - 1)}> <ChevronLeft />Prev </Button>
                    <div disabled className='px-2'>Page {pageNumber} of {numPages}</div>
                    <Button disabled={pageNumber >= numPages} variant='info' style={{backgroundColor: "#0076ff"}} onClick={() => setPageNumber(pageNumber + 1)}> Next <ChevronRight /></Button>
                </div>
            </div>
        </div>
    )

    return (
        <div className='d-flex justify-content-center'>
            <Card className='shadow bg-white'>
                <Card.Body>
                    <Document file={url} renderMode='canvas' onLoadSuccess={onDocumentLoadSuccess} >
                        {PageControl()}
                        <Page pageNumber={pageNumber} renderTextLayer={false} className="d-flex justify-content-center mx-auto" renderAnnotationLayer={false} scale={1.5} />
                        {PageControl()}
                    </Document>
                </Card.Body>
                {footer && <Card.Footer >
                        {footer}
                </Card.Footer>}
            </Card>
        </div>
      );
}

export default PDFReader